import React from 'react';
import "./App.scss";
import MainPage from "./pages";
import { initAnalytics } from './Util/analytics';
import { COMPANY_CONFIGS } from './Util/data/companyconfig';
initAnalytics();

function App() {
 
   const urlParams = new URLSearchParams(window.location.search);
   const companyParam = urlParams.get('company');

   const clearCompanyMode = () => {
      localStorage.removeItem('currentCompany');
      localStorage.removeItem('companyConfig');
   };
     
   console.log('company config', companyParam)
   if (companyParam) {
      if(companyParam.toLowerCase() === 'reset') {
         localStorage.removeItem('currentCompany');
         localStorage.removeItem('companyConfig');
      } else {
         const config = COMPANY_CONFIGS[companyParam.toLowerCase()];
         if (config) {
            localStorage.setItem('currentCompany', companyParam.toLowerCase());
            localStorage.setItem('companyConfig', JSON.stringify(config));
            console.log(`Company mode: ${config.name}`);
         } else {
            console.warn(`Unknown company: ${companyParam}`);
            clearCompanyMode();
         }
      }
   } 
   
   
   
   

   

   return(
      
      <MainPage />
      
   )

   // return <MainPage />;
}
export default App;
